import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { CourseService } from 'src/app/services/http/business/course/course.service';
import { ConfirmComponent } from '../../../../components/confirm/confirm.component';
import { SoundEnum } from '../../../../enums/sound.enum';
import { IConfirm } from '../../../../interfaces/confirm';
import { SnackBarService } from '../../../../services/common/snackBar.service';
import { RequestPrivateClassComponent } from '../request-private-class/request-private-class.component';

@Component({
  selector: 'app-request-private-class-list',
  templateUrl: './request-private-class-list.component.html',
  styleUrls: ['./request-private-class-list.component.css']
})
export class RequestPrivateClassListComponent implements OnInit {

  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "date",
    "package",
    "days",
    "branch",
    "timeStart",
    "timeEnd",
    "sessionCount",
    "status",
    "function"
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    public translate: TranslateService,
    private snackBar: SnackBarService,
    private courseService: CourseService,
  ) { }

  ngOnInit() {
    this.requestList();
  }

  requestList() {
    this.courseService.getPrivateClassRequestForUser().subscribe(res => {
      this.dataSource = null;
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }

  paginatorEvent(event) {
    this.courseService.getPrivateClassRequestForUser(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  getDays(days: string) {
    return days.split(',');
  }

  add() {
    this.dialog
      .open(RequestPrivateClassComponent, {
        width: '750px'
      })
      .afterClosed()
      .subscribe(() => {
        this.paginatorEvent(this.paginator);
      });
  }

  delete(data) {
    let confirm: IConfirm = {
      accept: true,
      message: "آیا از حذف درخواست اطمینان دارید؟",
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "500px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          const command = {
            Id: data.Id
          };
          this.courseService.DeletePrivateClassRequest(command).subscribe(() => {
            this.snackBar.OpenSnackBar(
              "درخواست با موفقیت حذف گردید",
              "ok",
              3000,
              SoundEnum.beep
            );
          });
          this.paginatorEvent(this.paginator);
        }
      });
  }

}
